import { AutogenLayoutdpRendition } from "./autogen/AutogenLayoutdpRendition";

export class dpRendition extends AutogenLayoutdpRendition {

  override async onLoad() {
    //Not Processed
    await this.sourceRenbill.search({ renb_done: "N", renb_billtype: "F" });
    this.textboxRendRecs.text = this.sourceRenbill.actualRowCount.toString();
    //Processed
    await this.sourceRenbill.search({ renb_done: "Y", renb_billtype: "F" });
    this.textboxRendProcRecs.text = this.sourceRenbill.actualRowCount.toString();
    //Total
    await this.sourceRenbill.search({ renb_billtype: "F" });
    this.textboxRendTotalRecs.text = this.sourceRenbill.actualRowCount.toString();
  }

}
